import WithBounds from './WithBounds';

export default WithBounds;
